import React from 'react'
// import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import { Button } from 'reactstrap'
import { FONTS } from '../../../../../constants'

export const NavBar = class extends React.Component {
  render() {
    const submitTab = get(this.props, 'submitTab')
    const toggleTab = get(this.props, 'toggleTab')
    return (
      <Wrapper>
        <Toggle
          style={ {
            color: submitTab === 1 ? 'white' : '',
            backgroundColor: submitTab === 1 ? '#AD2624' : '',
          } }
          onClick={ () => toggleTab(1) }
        >
        Actual Efficiency
        </Toggle>
        <Divider />
        <Toggle
          style={ {
            color: submitTab === 2 ? 'white' : '',
            backgroundColor: submitTab === 2 ? '#AD2624' : '',
          } }
          onClick={ () => toggleTab(2) }
        >
        Resource Utilization
        </Toggle>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  display: flex;
  font-family: ${FONTS.GOTHAM_MEDIUM};
`
const Toggle = styled(Button)`
  font-size: ${FONTS.SMALL_SIZE};
  background-color: white;
  color: black;
  margin-right: 10px;
  margin-left: 10px;
  height: 30px;
  border-radius: 20px;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const Divider = styled.div`
  border-left: 1px solid #CCCCCC;
  height: 30px;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-submit/tab/navbar.js